<template>
  <div class="kf-btn" @click="contactKf">
    <img src="@/assets/static/img/icon-kefu.png" alt="" class="icon-kf">
    <div class="kf-txt">在线客服</div>
  </div>
</template>

<script>
export default {
  name: 'ServiceBtn',
  data() {
    return {}
  },
  methods: {
    contactKf() {
      this.$axios.post('client/private-chat-sessions/add-customer-relation', {}).then(res => {
        if (res.code == 0) {
          this.$router.push({
            path: '/private/message#'+ res.data.u_code
          })
        } else {
          this.$notify.warning(res.message || '网络错误')
        }
      }).catch(() => {
        this.$notify.warning('网络错误')
      })
    }
  }
}
</script>

<style scoped>
.kf-btn{
  position: fixed;
  z-index: 10;
  right: 100px;
  bottom: 300px;
  width: 80px;
  height: 80px;
  background: #fff;
  box-shadow: #A60200 1px 1px 5px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 100%;
}
.kf-btn .icon-kf{
  width: 40px;
  height: 40px;
  display: block;
}
.kf-btn .kf-txt{
  font-size: 12px;
  color: #1A1A1A;
  line-height: 12px;
}
</style>
